module.exports = __webpack_public_path__ + "img/71714309.04032bd9.png";